<template>

    <!-- HEAD SECTION-->
<!-- HEADER-->
<interne_menu></interne_menu>	
        <!-- END HEADER -->
    <!-- END HEAD SECTION-->

    <!-- CONTACT SECTION-->
   <section id="contacts-1" class="bg-fixed bg-lightgrey wide-30 contacts-section division contact-bck">				
        <div class="container">

            <!-- section phone-->
            <div class="row r_space">


<!-- FEATURE BOX #1 -->
<div class="col-md-4 animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="300">
   <div class="fbox-1 box-icon-lg blue-icon">
       
       <!-- Icon -->
       <span class="pe-7s-map-marker color_v"></span>
           
       <!-- Title -->
       <h5 class="h5-md">NOTRE ADRESSE</h5>
           
       <!-- Text -->
       <p class="grey-color">Cocody Ambassade 10 Rue Washington Booker</p>				
           
   </div>							
</div>
       
       
<!-- FEATURE BOX #2 -->
<div class="col-md-4 animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="400">
   <div class="fbox-1 box-icon-lg blue-icon">
       
       <!-- Icon -->
       <span class="pe-7s-mail color_v"></span>
           
       <!-- Title -->
       <h5 class="h5-md">ADRESSE EMAIL</h5>

       <!-- Text -->
       <p class="grey-color">info@weblogy.com</p>								
   
   </div>							
</div>


<!-- FEATURE BOX #3 -->
<div class="col-md-4 animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="500">
   <div class="fbox-1 box-icon-lg blue-icon">
       
       <!-- Icon -->
       <span class="pe-7s-call color_v"></span>
           
       <!-- Title -->
       <h5 class="h5-md">TÉLEPHONE</h5>

       <!-- Text -->
       <p class="grey-color">+225 25 22 01 01 10</p>

   </div>							
</div>						


</div>


            <!-- SECTION TITLE -->	
            <div class="row">	
                <div class="col-md-10 offset-md-1 section-title">	

                    <!-- Title 	-->	
                    <h2 class="h2-lg">Nous Contacter</h2>	

                    <!-- Text -->
                    <p>Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins.</p>
                            
                </div> 	
            </div>	 <!-- END SECTION TITLE -->


            <!-- CONTACT FORM -->
            <div class="row">
                <div class="col-md-10 col-lg-10 offset-md-1 offset-lg-1">
                    <div class="form-holder">
                        <form name="contactform" class="row contact-form" novalidate="novalidate" method="post">
                                                                                
                            <!-- Contact Form Input -->
                            <div id="input-name" class="col-lg-6">
                                <input type="text" name="name" class="form-control name" placeholder="Votre nom*"> 
                            </div>
                                        
                            <div id="input-email" class="col-lg-6">
                                <input type="text" name="email" class="form-control email" placeholder=" Addresse Email*"> 
                            </div>
                                                
                            <!-- Form Select -->
                            <div id="input-subject" class="col-md-12 input-subject">
                                <select id="inlineFormCustomSelect1" name="Subject" class="custom-select subject">
                                    <option>Votre sujet...</option>	
                                    <option>Question</option>
                                    <option>Prise en charge</option>
                                    <option>information</option>
                                    <option>Plainte</option>
                                    <option>autre</option>
                                </select>
                            </div>
      
                            <div id="input-message" class="col-lg-12 input-message">
                                <textarea class="form-control message" name="message" rows="6" placeholder="Votre message ..."></textarea>
                            </div> 
                                                                                
                            <!-- Contact Form Button -->
                            <div class="col-lg-12 m-top-15 form-btn text-right">	
                                <button type="submit" class="btn btn-lightblue submit">Envoyer Message</button>	
                            </div>
                                                                                                                    
                            <!-- Contact Form Message -->
                            <div class="col-lg-12 contact-form-msg">
                                <span class="loading"></span>
                            </div>	
                                                                                    
                        </form>	
                    </div>	
                </div>	
            </div>	   <!-- END CONTACT FORM -->
            

        </div>	   <!-- End container -->		
	</section>
    <!-- END CONTACT SECTION-->

      <!-- CONTACT SECTION-->
   <section id="contacts-1" class="bg-fixed bg-lightgrey wide-29 contacts-section division">				
        <div class="container map_cont">


            <!-- SECTION TITLE -->	
            <div class="row">	
                <div class="col-md-12 col-lg-12 ">	
                    
                    <div id="map">
			<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d63561.20849947148!2d-4.024314337841698!3d5.328701098547401!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfc1eb47944c0395%3A0xbfae134df6015c32!2sAgence%20Weblogy%20Cocody!5e0!3m2!1sfr!2sci!4v1662134027544!5m2!1sfr!2sci" width="100%" height="500" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
			</div> 		
                
            </div> 	
            </div>	
             <!-- END SECTION TITLE -->


          

        </div>	   <!-- End container -->		
	</section>
    <!-- END CONTACT SECTION-->

     <!-- FOOTER -->
     <footer_menu></footer_menu>
        <!-- END FOOTER -->
</template>
<script>

import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';
export default{

    name :'nous_contacter',
    components : {
      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu,
   
    } 
}
</script>

<style scoped>
.footer-stores-badge{
    text-align: left!important;;
}
.navbar-dark .navbar-nav .nav-link {
    color: #000;
}
.img_pci {
    filter: grayscale(99%);
    transition-duration: 0.5s;
    opacity: 0.5;
}
.img_pci:hover {
    filter: grayscale(10%);
    transition-duration: 0.5s;
    opacity: 1;
}
.fa-heart{
    color: #e90404;
}
.wide-30 {
    padding-top: 210px;
    padding-bottom: 30px;
}
.wide-29 {
    padding-top: 50px;
    padding-bottom: 30px;
}
.header-socials a {
    width: 38px;
    height: 38px;
    background-color: transparent;
    display: block;
    color: #030201;
    font-size: 1rem;
    line-height: 34px !important;
    border: 2px solid #fff;
    margin-left: 3px;
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    border-radius: 100%;
}
.btn-lightblue {
    color: #fff;
    background-color: #ff9e00;
    border-color: #fdb543;
}
.map_cont{
    max-width: 100%;
}
.bg-lightgrey {
    background-color: #ffffff;
}
.blue-icon span {
    background: -webkit-gradient(linear, left top, left bottom, from(#ff9e00), to(#ff9e00));
    -webkit-background-clip: text;
    -webkit-text-fill-color: #00000000;
}
.r_space{
    margin-bottom: 50px;
}
.box-icon-lg span {
    font-size: 4rem;
}
</style>